/**
 * Whether the app offers recharging orbs at all: the wallet's "Agregar saldo"
 * button, the recharge sheet (`AddCreditsSheet`) and any copy that points the
 * learner to buying ("Cargá orbs desde Inicio").
 *
 * - **Web**: yes. There is no web checkout; the sheet explains that recharging
 *   lives in the mobile app (Fase 23, monetización (b)).
 * - **Native**: only while `isPurchaseAvailable()` (the platform's RevenueCat
 *   key is baked into the build). A store build without it — iOS 1.0, whose
 *   in-app purchases wait on the Paid Apps Agreement — shows no purchase UI at
 *   all: a disabled "coming soon" sheet reads as an unfinished feature to App
 *   Review (2.1 / 2.2). Driven by the key, not by the platform, so the purchase
 *   UI comes back by itself on the first build that has it.
 */
import { isNative } from '../lib/platform.js';
import { isPurchaseAvailable } from './revenuecat.js';

export function isRechargeOffered(): boolean {
  return !isNative || isPurchaseAvailable();
}
